module.exports = __webpack_public_path__ + "img/settingsCalendar.bae5e375.svg";